var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategyThematic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 9,
    fill: "#D9D2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 1C5.48743 1 1 5.48595 1 10.9992C1 16.5125 5.48743 21 11.0007 21C16.5141 21 21.0015 16.5125 21.0015 10.9992C21.0015 5.48595 16.5141 1 11.0007 1ZM11.7714 2.57441C16.0903 2.96211 19.4601 6.5772 19.4601 10.9992C19.4601 15.4213 16.0903 19.0364 11.7714 19.4241V2.57441Z",
    fill: "#523FC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyThematic);
export default __webpack_public_path__ + "static/media/strategy-thematic.0516d6919ff24cc1ad0b9fc94ec2cd3d.svg";
export { ForwardRef as ReactComponent };